export default __webpack_public_path__ + "static/media/K.71c5f163.mp3";